<template>
	<div class="card md-elevation-4" style="background-color: #ff8a65; color: white">
		<div style="display: flex; width: 100%">
			<div style="margin-top: auto; margin-bottom: auto">
				<md-progress-spinner
					v-if="users.all === undefined"
					md-mode="indeterminate"
					:md-diameter="30"
					:md-stroke="3"
					class="md-accent"
				/>
				<md-icon v-else class="md-size-2x" style="color: white">person</md-icon>
			</div>
			<div style="margin-left: auto; margin-right: 0px; margin-top: auto; margin-bottom: auto">
				<strong style="font-size: 32px">
					{{ users.all }}
				</strong>
			</div>
			<br />
		</div>
		<span style="float: right"
			>{{ $t("registered-users") }} (+{{ users.thisYear }} {{ $t("since-beginning-year") }})</span
		>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
	name: "users-chart",
	data() {
		return {}
	},

	computed: {
		...mapGetters({
			users: "dashboard/usersNumber"
		})
	}
}
</script>

<style scoped lang="scss">
.card {
	width: auto;
	height: 115px;
	padding: 20px;
	border-radius: 15px;
	background-color: white;
	margin: 5px;
	&:hover {
		cursor: pointer;
	}
	color: #ff8a65;
}

.positive {
	color: green;
}
.negative {
	color: red;
}
.equal {
	color: gray;
}
span,
strong {
	font-family: "Montserrat", sans-serif;
}
</style>
